import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import Header from '../components/Header';
import Footer from '../components/Footer';

// Unconnected component (stateless functional component)
export const PrivateRoute = ({
    isAuthenticated,
    component: Component,
    ...rest
}) => (
    <Route {...rest} component={(props) => (
        isAuthenticated ? (
            <div>
                <div className="inner_notice_text">
                    <div className="box-layout__box inner_upgrade_notice">
                        <div className="logo-link_div">
                            <a href="" className="logo-link"><img className="main-logo" src="/images/FullLogo_Transparent_NoBuffer.png"></img></a>
                        </div>
                        <div className="notice notice__warning">
                            <p>This site is best viewed on iOS 12 devices, Galaxy 20 Plus/Ultra devices, or later. Please use one of the late model devices specified or view our site on a desktop.</p>
                        </div>
                    </div>
                </div>
                <div className="push_element">
                    <div className="inner_page_layout">
                        <Header />
                        <div className="dashboard_page">
                            <Component {...props} />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>       
        ) : (
            <Redirect to="/"/>
        )
    )}/>
);

const mapStateToProps = (state) => ({
    isAuthenticated: !!state.auth.uid
});

export default connect(mapStateToProps)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/routers/PrivateRoute.js